import styled from "styled-components";

const IconChange = styled.img.attrs({
  src: "/assets/images/change-icon.png",
  alt: "Change State",
  title: "Change State"
})`
  cursor: pointer;
  height: 12px;
  padding-left:5px;
`;
IconChange.displayName = "ChangeState";

export default IconChange;
